import React, { useState, useRef, useCallback } from 'react';
import ScrollReveal from './ScrollReveal';
import { trackCarouselNavigate } from '../utils/analytics';

const scenes = [
  { label: 'Infrastructure', desc: 'Connects to your existing camera system. No new hardware required.' },
  { label: 'Edge Processing', desc: 'On-site AI device processes all video streams locally in real time.' },
  { label: 'Analytics Engine', desc: 'Raw footage becomes structured, non-identifying metrics automatically.' },
  { label: 'Transmission', desc: 'Only lightweight analytics data is transmitted. No video leaves the site.' },
  { label: 'Dashboard', desc: 'Live KPIs, heatmaps, trend analysis, and multi-site views at your fingertips.' },
];

export default function AnimationEmbed() {
  const [active, setActive] = useState(0);
  const iframeRef = useRef(null);

  const goTo = useCallback((index) => {
    const clamped = Math.max(0, Math.min(index, scenes.length - 1));
    setActive(clamped);
    trackCarouselNavigate(clamped, scenes[clamped].label.toLowerCase().replace(/\s+/g, '_'));
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ type: 'goToScene', index: clamped }, '*');
    }
  }, []);

  return (
    <section className="animation-section" id="how-it-works">
      <div className="section-inner" style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div className="section-label">How It Works</div>
        <ScrollReveal>
          <h2 className="section-title">
            Camera feeds in. <strong>Structured analytics out.</strong>
          </h2>
        </ScrollReveal>
      </div>
      <ScrollReveal>
        <div className="animation-container">
          <iframe
            ref={iframeRef}
            src={process.env.PUBLIC_URL + '/vision-animation.html'}
            style={{ width: '100%', height: '100%', border: 'none' }}
            loading="lazy"
            title="Oscilabs Vision Animation"
          />

          {/* Active scene description */}
          <p className="carousel-desc">{scenes[active].desc}</p>

          {/* Bottom control bar with arrows + dots */}
          <div className="carousel-controls">
            <button
              className="carousel-arrow carousel-prev"
              onClick={() => goTo(active - 1)}
              disabled={active === 0}
              aria-label="Previous scene"
            >
              &#8592;
            </button>
            <div className="carousel-dots">
              {scenes.map((s, i) => (
                <button
                  key={i}
                  className={`carousel-dot${i === active ? ' active' : ''}`}
                  onClick={() => goTo(i)}
                  aria-label={`Go to scene: ${s.label}`}
                >
                  <span className="carousel-dot-num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="carousel-dot-label">{s.label}</span>
                </button>
              ))}
            </div>
            <button
              className="carousel-arrow carousel-next"
              onClick={() => goTo(active + 1)}
              disabled={active === scenes.length - 1}
              aria-label="Next scene"
            >
              &#8594;
            </button>
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
}
